import { useMutation } from "react-query";
import { deleteFamilyMedicalHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useDeleteFamilyMedicalHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteFamilyMedicalHistory(id),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while deleting the family medical history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    deleteFamilyMedicalHistoryMutation: mutate,
    isDeleteFamilyMedicalHistoryLoading: isLoading,
    ...rest,
  };
};

export default useDeleteFamilyMedicalHistory;
